(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvAbnInput', drvAbnInput);
        
    drvAbnInput.$inject = [];

        /**
         * @ngdoc directive
         * @name drvAbnInput
         * @description Abn input which includes validation.
         *
         * @param {string} value - Abn
         * @param {object} field - An entity field object
         */
        function drvAbnInput() {
            drvAbnInputCtrl.$inject = [];

            return  {
                templateUrl: 'app/fieldinput/abn-input.tmpl.html',
                require: "ngModel",
                scope: {
                },
                controller: drvAbnInputCtrl,
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                },
                link: link
            };

            function drvAbnInputCtrl() {
                /* jshint validthis:true */
                var drvCtrl = this;
                drvCtrl.validateAbn = validateAbn;

                /*
                 * Check to see if the Abn is valid
                 */
                function validateAbn(abn) {
                    var valid = false;

                    if (!_.isNil(abn) && abn !== '') {
                        if (abn.length == 11 && !isNaN(abn)) {
                            var sumTotal = 0;

                            for (var i = 0; i < 11; i++) {
                                var digitInt = parseInt(abn[i]);

                                if (i === 0) {
                                    digitInt += -1;
                                }

                                sumTotal += digitInt * getWeighting(i);
                            }

                            valid = sumTotal % 89 === 0;
                        }
                    } else {
                        valid = true;
                    }

                    return valid;
                }

                function getWeighting(index) {
                    var result;

                    switch (index)
                    {
                        case 0:
                            result = 10;
                            break;
                        case 1:
                            result = 1;
                            break;
                        case 2:
                            result = 3;
                            break;
                        case 3:
                            result = 5;
                            break;
                        case 4:
                            result = 7;
                            break;
                        case 5:
                            result = 9;
                            break;
                        case 6:
                            result = 11;
                            break;
                        case 7:
                            result = 13;
                            break;
                        case 8:
                            result = 15;
                            break;
                        case 9:
                            result = 17;
                            break;
                        case 10:
                            result = 19;
                            break;
                    }

                    return result;
                }
            }
        }

        /*
         * Link function which will handle validation
         */
        function link($scope, $element, $attrs, $ctrl) {
            $scope.pni[$scope.drvCtrl.field.Name].$validators.formatValid = function required(modelValue, viewValue) {
                return $scope.drvCtrl.validateAbn(modelValue);
            };
        }
})();